export default __webpack_public_path__ + "static/media/mrightrock.12dcbb4f.png";